<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store.js';
import { isSalesInbox } from 'dashboard/helper/inbox';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const emit = defineEmits(['select', 'close']);
const { t } = useI18n();
const dialogRef = defineModel('dialogRef', { type: Object, default: null });

const inboxesAll = useMapGetter('inboxes/getAllInboxes');

const salesInboxes = computed(() =>
  inboxesAll.value.filter(inbox => isSalesInbox(inbox))
);

const handleSelect = inbox => {
  emit('select', inbox);
};

const open = () => {
  dialogRef.value?.open();
};

const close = () => {
  dialogRef.value?.close();
};

const onDialogClose = () => {
  emit('close');
};

defineExpose({ open, close, salesInboxes });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="t('CHAT_LIST.SALES_ASSIST.PICK_INBOX_TITLE')"
    :description="t('CHAT_LIST.SALES_ASSIST.PICK_INBOX_DESC')"
    :show-confirm-button="false"
    :show-cancel-button="false"
    width="md"
    @close="onDialogClose"
  >
    <div v-if="salesInboxes.length" class="flex flex-col gap-2">
      <Button
        v-for="inbox in salesInboxes"
        :key="inbox.id"
        variant="faded"
        color="slate"
        :label="inbox.name"
        icon="i-lucide-inbox"
        class="w-full justify-start"
        @click="handleSelect(inbox)"
      />
    </div>
    <p v-else class="text-sm text-n-slate-11 text-center py-4">
      {{ t('CHAT_LIST.SALES_ASSIST.NO_SALES_INBOX') }}
    </p>
  </Dialog>
</template>
